import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { State } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid';

// @Le - BaseGridService would replace current ODataService<T>
export abstract class BaseGridService extends BehaviorSubject<GridDataResult> {
  public loading = false;
  public state: State = {
    skip: 0,
    take: 10,
    sort: [{ field: 'name', dir: 'asc' }],
    filter: {
      logic: 'and',
      filters: []
    }
  };

  protected http = inject(HttpClient);
  
  protected abstract get baseUrl(): string;

  constructor() {
    super({ data: [], total: 0 });
    this.read();
  }

  public read(): void {
    this.loading = true;
    this.fetch()
      .subscribe(result => {
        this.loading = false;
        super.next(result);
      });
  }

  public onStateChange(state: State): void {
    this.state = state;
    this.read();
  }

  protected fetch(): Observable<GridDataResult> {
    const pageSize = this.state.take;
    const page = this.state.skip! / pageSize! + 1;
    
    let ordering = '';
    if (this.state.sort && this.state.sort.length > 0) {
      ordering = this.state.sort[0].dir === 'desc' ? 
        `-${this.state.sort[0].field}` : 
        this.state.sort[0].field;
    }

    let url = `${this.baseUrl}?page=${page}&page_size=${pageSize}`;
    if (ordering) {
      url += `&ordering=${ordering}`;
    }

    if (this.state.filter && this.state.filter.filters.length > 0) {      
      // todo: @Le - filtering placholder
    }

    return this.http.get<any>(url).pipe(
      map(response => {
        return {
          data: response.results,
          total: response.count
        };
      })
    );
  }
}